import React, { useCallback, useMemo } from 'react'
import Select from "react-select"
import { optionize, pipe } from "../../../utilities/utils"
import { positionSort } from "../../../utilities/mobileRecordHelper"

const DropdownValue = ({ field, value, callback }) => {
  const formattedValue = useMemo(() => Array.isArray(value) ? value : [value], [value])
  const orderedOptions = useMemo(() => pipe(positionSort, optionize('value'))(field?.options), [field])
  const selectedOptions = useMemo(() => orderedOptions.filter(i => formattedValue.includes(i.value)), [orderedOptions, value])
  const onChangeHandler = useCallback((event) => callback(event?.value || event.map(e => e.value)), [callback])

  return (
    <Select
      options={orderedOptions}
      onChange={onChangeHandler}
      className="resize max-w-full w-full"
      value={selectedOptions}
      isMulti={field?.multi_select}
    />
  )
}

export default DropdownValue
